import { LanguageStateModel } from "./language-state.model";

export class AddLanguage {
    static readonly type = '[Language] Add';

    constructor(public payload: LanguageStateModel) {
    }
}

export class GetLanguages {
    static readonly type = '[Languages] Get';
}

export class UpdateLanguage {
    static readonly type = '[Language] Update';

    constructor(public payload: LanguageStateModel, public id: number) {
    }
}

export class DeleteLanguage {
    static readonly type = '[Language] Delete';

    constructor(public id: number) {
    }
}

export class SetSelectedLanguage {
    static readonly type = '[Language] Set';

    constructor(public payload: LanguageStateModel) {
    }
}